module.exports = __webpack_public_path__ + "img/icon-4-bg.2ea36249.png";